var _path, _path2, _path3, _path4;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSmiley(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M0 12C0 5.37256 5.37258 0 12 0C18.6244 0.00708008 23.9928 5.37549 24 12C24 18.6274 18.6274 24 12 24C5.37258 24 0 18.6274 0 12ZM2 12C2 17.5229 6.47715 22 12 22C17.5203 21.9939 21.9939 17.5203 22 12C22 6.47705 17.5228 2 12 2C6.47715 2 2 6.47705 2 12Z",
    fill: "currentColor"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M16.492 14.13C16.0115 13.8585 15.4019 14.0277 15.13 14.508C14.5261 15.6913 13.3278 16.454 12 16.5C10.6722 16.454 9.47389 15.6913 8.87 14.508C8.58932 14.0469 7.99342 13.8918 7.52359 14.1575C7.05376 14.4232 6.87956 15.0138 7.13 15.492C8.08351 17.3075 9.94966 18.4602 12 18.5C14.0503 18.4602 15.9165 17.3075 16.87 15.492C17.1414 15.0114 16.9722 14.4019 16.492 14.13Z",
    fill: "currentColor"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M8 11C9.10457 11 10 10.1046 10 9C10 7.89543 9.10457 7 8 7C6.89543 7 6 7.89543 6 9C6 10.1046 6.89543 11 8 11Z",
    fill: "currentColor"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M16 11C17.1046 11 18 10.1046 18 9C18 7.89543 17.1046 7 16 7C14.8954 7 14 7.89543 14 9C14 10.1046 14.8954 11 16 11Z",
    fill: "currentColor"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSmiley);
export default __webpack_public_path__ + "static/media/smiley.6de46ef0.svg";
export { ForwardRef as ReactComponent };